import type { IScenario } from 'commonTypes/api/scenarios/scenario';
import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { INextStep } from './types';

interface IStartFlowQuery {
  scenario?: string;
}

export const scenarioApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    nextStep: build.mutation<IScenario, INextStep>({
      query: (query) => ({
        url: BFF_API_ROUTES.next,
        method: 'POST',
        body: query,
      }),
    }),
    sendStep: build.mutation<unknown, Omit<INextStep, 'payload'>>({
      query: (query) => ({
        url: BFF_API_ROUTES.step,
        method: 'POST',
        body: query,
      }),
    }),
    startFlow: build.mutation<{ item: string }, IStartFlowQuery>({
      query: (query) => ({
        url: BFF_API_ROUTES.start,
        method: 'POST',
        ...(query.scenario ? { params: query } : {}),
      }),
    }),
    getOfferDisbursementStep: build.query<IScenario, string>({
      query: (hashedDealId) => ({
        url: BFF_API_ROUTES.offerDisbursementStep,
        method: 'GET',
        params: { hashedDealId },
      }),
    }),
  }),
});

export const useNextStep = scenarioApi.useNextStepMutation;
export const useStartFlow = scenarioApi.useStartFlowMutation;
export const useSendStepFlow = scenarioApi.useSendStepMutation;
